import {
 HttpEvent,
 HttpInterceptor,
 HttpHandler,
 HttpRequest,
 HttpResponse,
 HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { tap,retry, catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router) {}
 intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   return next.handle(request)
     .pipe(
         retry(1),
         catchError((error: HttpErrorResponse) => {
           const statusCode = error.status;
           const ignoreRoutes = ['/admin/login', '/staff/email-login','/enquiry/login'];
           const currentUrl = this.router.url;
            if (statusCode === 401 && ignoreRoutes.indexOf(currentUrl) === -1) {
                this.router.navigate(['session-expired']);
            }
            return throwError(error);
       })
     );
 }
}
